export enum InsurancePlanType {
  PrivateCommercial = 0,
  MedicarePartD = 1,
  MedicareAdvantage = 2,
  Medicaid = 3,
  VAOrMilitary = 4
}
